import React from "react";
import { SystemmeldingSingle } from "./SystemmeldingSingle";
import { SystemmeldingAccordion } from "./SystemmeldingAccordion";

interface Props {
	systemmeldinger?: string[];
}
export const Systemmelding: React.FC<Props> = (props: Props) => {
	const { systemmeldinger } = props;

	if (!systemmeldinger || systemmeldinger.length === 0) return null;

	if (systemmeldinger.length === 1) {
		return <SystemmeldingSingle systemmelding={systemmeldinger[0]} />;
	}

	if (systemmeldinger.length > 1) {
		return <SystemmeldingAccordion systemmeldinger={systemmeldinger} />;
	} else {
		return null;
	}
};
